module.exports = __webpack_public_path__ + "static/media/banner.f7124926.jpg";